<template>
  <div style="height:100%;width:100%;">
    <div class="news_title">
      投诉与咨询服务
      <span class="iconfont">&#xe70b;</span>12328投诉统计
      <span class="iconfont">&#xe70b;</span>月报
    </div>
    <div class="newsContent" v-show="state1">
      <ul v-for="(item,index) in tableDatas" :key="index">
        <li @click="intoNextPage(item.table_time)">{{item.table_time | formatterTitle}}12328投诉统计月报公示</li>
      </ul>
    </div>
    <div v-if="table_state" style="padding:5px;">
      <table>
        <tr>
          <td colspan="10" style="font-size:20px;font-weight:bold;text-align:center;"
          >12328出行服务中心{{table_data.title | formatterTitle}}份投诉举报业务报表</td>
        </tr>
        <tr>
          <td rowspan="4" style="word-wrap:break-word;width:30px;background:#98bdd6;vertical-align:middle;text-align:center;"
          >电话受理</td>
          <td
            colspan="6"
            style="vertical-align:middle;text-align:center;background:#c4dcec;"
          >下发工单（起）</td>
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">现场回复（起）</td>
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">共接电话合计（起）</td>
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">备注</td>
        </tr>
        <tr>
          <!-- <td></td> -->
          <td colspan="6" style="vertical-align:middle;text-align:center;background:#eff5fb;"
          >{{table_data.work_order_num}}</td>
          <td style="vertical-align:middle;text-align:center;background:#eff5fb;"
          >{{table_data.locale_reply}}</td>
          <td style="vertical-align:middle;text-align:center;background:#eff5fb;"
          >{{table_data.tel_number}}</td>
          <td style="vertical-align:middle;text-align:center;background:#eff5fb;"></td>
        </tr>
        <tr style="height:200px;">
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">统计汇总</td>
          <td colspan="8" style="background:#eff5fb;vertical-align:middle;font-size:14px;padding:5px;"
          >{{table_data.statistical_summary}}</td>
        </tr>
        <tr style="height:200px;">
          <!-- <td></td> -->
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">突出重点</td>
          <td colspan="9" style="background:#eff5fb;vertical-align:middle;font-size:14px;padding:5px;"
          >{{table_data.emphasize}}</td>
        </tr>
        <!-- ------------------------------------------------------------------------------------ -->
        <tr>
          <td rowspan="3" style="word-wrap:break-word;width:30px;background:#98bdd6;vertical-align:middle;text-align:center;">市长热线</td>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#c4dcec;">转办</td>
          <td colspan="4" style="vertical-align:middle;text-align:center;background:#c4dcec;">超时</td>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#c4dcec;">回复</td>
        </tr>
        <tr>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.captain_transfer}}</td>
          <td colspan="4" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.captain_outtime}}</td>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.captain_reply}}</td>
        </tr>
        <tr style="height:200px;">
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">突出重点</td>
          <td colspan="9" style="background:#eff5fb;vertical-align:middle;font-size:14px;padding:5px;">{{table_data.captain_key}}</td>
        </tr>
        <!-- ------------------------------------------------------------------------------------ -->
        <tr>
          <td rowspan="3" style="word-wrap:break-word;width:30px;background:#98bdd6;vertical-align:middle;text-align:center;">微信公众平台</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#c4dcec;">关注人数</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#c4dcec;">直接回复</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#c4dcec;">书面形式回复</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#c4dcec;">回复合计</td>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#c4dcec;">备注</td>
        </tr>
        <tr>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.wet_person}}</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.wet_reply}}</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.wet_bookreply}}</td>
          <td colspan="2" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.wet_replyall}}</td>
          <td colspan="3" style="vertical-align:middle;text-align:center;background:#eff5fb;">{{table_data.wet_remark}}</td>
        </tr>
        <tr style="height:200px;">
          <td style="vertical-align:middle;text-align:center;background:#c4dcec;">突出重点</td>
          <td colspan="10" style="background:#eff5fb;vertical-align:middle;font-size:14px;padding:5px;">{{table_data.wet_key}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { ipconfig } from "@/assets/js/ipconfig.js";
import Axios from "axios";
export default {
  name: "tsjb",
  data() {
    return {
      year: "2019",
      state1: true,
      table_state: false,
      table_data: {
        title: "",
        work_order_num: "",
        locale_reply: "",
        tel_number: "",
        statistical_summary: "",
        emphasize: "",
        captain_key: "",
        captain_outtime: 0,
        captain_reply: 0,
        captain_transfer: 0,
        wet_bookreply: 0,
        wet_key: "",
        wet_person: 0,
        wet_remark: "",
        wet_reply: 0,
        wet_replyall: 0,
      },
      tableDatas: []
    };
  },
  mounted() {
    this.getDatas();
  },
  filters: {
    formatterTitle: function(val) {
      if (val) {
        return val.split("-")[0] + "年" + val.split("-")[1] + "月";
      }
    }
  },
  methods: {
    intoNextPage(val) {
      let url ="http://" +ipconfig +"/app/isweb/comAll/getComplainAll?con_table_time="+val;
      Axios.get(url).then(res => {
        if (res.data.isSuccess) {
          this.table_data.title = res.data.data.complainAll[0].table_time;
          this.table_data.work_order_num = res.data.data.complainAll[0].phone_order;
          this.table_data.locale_reply = res.data.data.complainAll[0].phone_reply;
          this.table_data.tel_number = res.data.data.complainAll[0].phone_reply;
          this.table_data.statistical_summary = res.data.data.complainAll[0].phone_count;
          this.table_data.emphasize = res.data.data.complainAll[0].phone_key;
          this.table_data.captain_key = res.data.data.complainAll[0].captain_key
          this.table_data.captain_outtime = res.data.data.complainAll[0].captain_outtime
          this.table_data.captain_reply = res.data.data.complainAll[0].captain_reply
          this.table_data.captain_transfer = res.data.data.complainAll[0].captain_transfer
          this.table_data.wet_bookreply= res.data.data.complainAll[0].wet_bookreply
          this.table_data.wet_key= res.data.data.complainAll[0].wet_key
          this.table_data.wet_person= res.data.data.complainAll[0].wet_person
          this.table_data.wet_remark= res.data.data.complainAll[0].wet_remark
          this.table_data.wet_reply= res.data.data.complainAll[0].wet_reply
          this.table_data.wet_replyall=res.data.data.complainAll[0].wet_replyall
          this.state1 = false;
          this.table_state = true;
        }
      });
    },
    returnYears: function(arg) {
      let d = new Date(arg);
      let resDate = d.getFullYear();
      return resDate;
    },
    getDatas() {
      // this.loading = true;
      // let _year = this.year;
      // if (!_year) {
      //   _year = "2019";
      // }
      let url = "http://" + ipconfig + "/app/isweb/comAll/getComplainAll";
      //let url = "http://localhost:8001/app/isweb/comAll/getComplainAll";
      // if (!this.currentPage) {
      //   this.currentPage = 1;
      // }
      // let param = new URLSearchParams();
      // param.append("con_table_time", this.returnYears(_year));
      // param.append("con_PageNumber",1);
      // param.append("con_PageSize", 15);
      Axios.get(url).then(res => {
        if (res.data.isSuccess) {
          this.tableDatas = res.data.data.complainAll;
          console.log(res);
          // this.loading = false;
          // this.sumnum = res.data.data.sumnum;
          // this.tableData = res.data.data.complainAll;
        }
      });
    }
  }
};
</script>
<style scoped>
table {
  width: 100%;
  border: 1px solid #6ba6d8;
  margin-bottom: 5px;
}
table tr td {
  width: 15%;
  border-right: 1px solid #6ba6d8;
  border-bottom: 1px solid #6ba6d8;
  /* text-align: center; */
  /* display: flex;
  justify-content: center;
  align-items: center; */
}
.table2 tr td {
  width: 20%;
}
.newsContent ul li {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px dashed #ccc;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/pages/tszxsevers/statistics_month.vue


// WEBPACK FOOTER //
// src/pages/tszxsevers/statistics_month.vue